var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".network_svg__cls-1{fill:#669df6;fill-rule:evenodd}.network_svg__cls-2{fill:#4285f4}.network_svg__cls-3{fill:#aecbfa}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "network_svg__cls-1",
    d: "M4.94 13.7l6.59 6.52 1.09-1.15-6.32-6.14-1.36.77zM12.57 4.06l-1.09 1.16 6.21 6.22 1.78-.38-6.9-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "network_svg__cls-2",
    d: "M11.38 5.13h1.25v5h-1.25zM11.38 14.5h1.25v5h-1.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "network_svg__Oval",
    className: "network_svg__cls-3",
    cx: 12,
    cy: 4.5,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "network_svg__cls-3",
    cx: 12,
    cy: 19.5,
    r: 1.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "network_svg__cls-1",
    d: "M2.66 11.38h15.07l3.64 1.87H6.3l-3.64-1.87z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "network_svg__cls-3",
    cx: 4.5,
    cy: 12.31,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "network_svg__cls-3",
    cx: 19.5,
    cy: 12.31,
    r: 2.5
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM2NjlkZjY7ZmlsbC1ydWxlOmV2ZW5vZGQ7fS5jbHMtMntmaWxsOiM0Mjg1ZjQ7fS5jbHMtM3tmaWxsOiNhZWNiZmE7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5JY29uXzI0cHhfTmV0d29ya19Db2xvcjwvdGl0bGU+PGcgZGF0YS1uYW1lPSJQcm9kdWN0IEljb25zIj48ZyA+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjQuOTQgMTMuNyAxMS41MyAyMC4yMiAxMi42MiAxOS4wNyA2LjMgMTIuOTMgNC45NCAxMy43Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjEyLjU3IDQuMDYgMTEuNDggNS4yMiAxNy42OSAxMS40NCAxOS40NyAxMS4wNiAxMi41NyA0LjA2Ii8+PHJlY3QgY2xhc3M9ImNscy0yIiB4PSIxMS4zOCIgeT0iNS4xMyIgd2lkdGg9IjEuMjUiIGhlaWdodD0iNSIvPjxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iMTEuMzgiIHk9IjE0LjUiIHdpZHRoPSIxLjI1IiBoZWlnaHQ9IjUiLz48Y2lyY2xlIGlkPSJPdmFsIiBjbGFzcz0iY2xzLTMiIGN4PSIxMiIgY3k9IjQuNSIgcj0iMS44OCIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iMTIiIGN5PSIxOS41IiByPSIxLjg4Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjIuNjYgMTEuMzggMTcuNzMgMTEuMzggMjEuMzcgMTMuMjUgNi4zIDEzLjI1IDIuNjYgMTEuMzgiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjQuNSIgY3k9IjEyLjMxIiByPSIyLjUiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjE5LjUiIGN5PSIxMi4zMSIgcj0iMi41Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgNetwork as ReactComponent };